import { Heading, color, Box } from '@chakra-ui/react'
import 'swiper/css/effect-coverflow'
import 'swiper/css/navigation'
import 'swiper/css'
import 'swiper/css/pagination'
import '../extra-styles.css'
import { BrightNess, LightColorName, Walkway } from '../../../Data/Types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow, Navigation, Pagination, Virtual } from 'swiper'
import ResultCard from '../ResultCard'
import WalkwayResults from './WalkwayResults'
import VirtualLinesResults from '../VirtualLineResults/VirtualLinesResults'

export interface WalkwayResult {
	projectorNumber: 1 | 2
	walkway: Walkway
	brightness: BrightNess
}

interface ResultsProps {
	results: WalkwayResult[]
	isMobile: boolean
}
const WalkwayResultsCards: React.FC<ResultsProps> = ({ results, isMobile }) => {
	return (
		<>
			<Heading
				borderTopRadius={'xl'}
				width="100%"
				textAlign="center"
				py={{ base: '0.5rem', md: 0 }}
				size={{ base: 'lg', md: 'xl' }}
			>
				Recommended Results
			</Heading>

			{isMobile ? (
				<Box pb={'1rem'}>
					<Swiper
						virtual
						style={
							{
								'--swiper-navigation-color': 'var(--chakra-colors-orange-500)',
								'--swiper-pagination-color': 'var(--chakra-colors-orange-500)',
							} as React.CSSProperties
						}
						effect={'coverflow'}
						centeredSlides={true}
						grabCursor={true}
						coverflowEffect={{
							rotate: 100,
							stretch: 0,
							depth: 100,
							modifier: 1,
							slideShadows: true,
						}}
						pagination={{ clickable: true }}
						modules={[EffectCoverflow, Navigation, Pagination, Virtual]}
						navigation={true}
					>
						{results.map((result, index) => (
							<SwiperSlide virtualIndex={index} key={index}>
								<ResultCard brightness={result.brightness}>
									<WalkwayResults
										projectorNumber={result.projectorNumber}
										walkway={result.walkway}
									></WalkwayResults>
								</ResultCard>
							</SwiperSlide>
						))}
					</Swiper>
				</Box>
			) : (
				results.map((result, index) => (
					<ResultCard brightness={result.brightness} key={index}>
						<WalkwayResults
							projectorNumber={result.projectorNumber}
							walkway={result.walkway}
						></WalkwayResults>
					</ResultCard>
				))
			)}
		</>
	)
}

export default WalkwayResultsCards
